
const { mapState, mapGetters } = require('vuex')

export default {
  data: () => ({
    datasets: null,
    page: 1,
    loading: false,
    filters: {},
    filtered: false,
    facetsValues: {
      status: [],
      draftStatus: [],
      visibility: [],
      services: [],
      concepts: [],
      topics: [],
      publicationSites: [],
      requestedPublicationSites: []
    },
    lastParams: null,
    dataSvg: require('~/assets/svg/Data Arranging_Two Color.svg?raw'),
    renderMode: null,
    filtersInitialized: false
  }),
  computed: {
    ...mapState('session', ['user']),
    ...mapGetters('session', ['activeAccount']),
    ...mapState(['env']),
    plural () {
      return this.datasets.count > 1
    },
    size () {
      return { xs: 12, sm: 12, md: 12, lg: 15, xl: 24 }[this.$vuetify.breakpoint.name]
    },
    hasDatasets () {
      return !this.datasets || this.datasets.count
    },
    renderModeKey () {
      return `${this.user.id}:datasets:render-mode`
    },
    sorts () {
      return [
        { value: 'createdAt:-1', text: this.$t('sortCreatedAtDesc') },
        { value: 'createdAt:1', text: this.$t('sortCreatedAtAsc') },
        { value: 'updatedAt:-1', text: this.$t('sortUpdatedAtDesc') },
        { value: 'updatedAt:1', text: this.$t('sortUpdatedAtAsc') },
        { value: 'dataUpdatedAt:-1', text: this.$t('sortDataUpdatedAtDesc') },
        { value: 'dataUpdatedAt:1', text: this.$t('sortDataUpdatedAtAsc') }
      ]
    }
  },
  watch: {
    facetsValues: {
      deep: true,
      handler () {
        this.refresh()
      }
    },
    renderMode (newValue, oldValue) {
      localStorage.setItem(this.renderModeKey, this.renderMode)
      if (oldValue !== null) this.refresh()
    }
  },
  mounted () {
    this.renderMode = Number(localStorage.getItem(this.renderModeKey) || 0)
    if (isNaN(this.renderMode)) this.renderMode = 0
    this.refresh()
  },
  methods: {
    onScroll (e) {
      if (!this.datasets || this.loading) return
      const se = e.target.scrollingElement
      if (se.clientHeight + se.scrollTop > se.scrollHeight - 140 && this.datasets.results.length < this.datasets.count) {
        this.refresh(true)
      }
    },
    async refresh (append) {
      if (!this.filtersInitialized) return
      const fullFilters = { ...this.filters }
      let hasFacetFilter = false
      Object.entries(this.facetsValues).forEach(([facetKey, facetValues]) => {
        const facetFilter = facetValues && facetValues.join(',')
        if (facetFilter) {
          hasFacetFilter = true
          fullFilters[facetKey] = facetFilter
        }
      })
      if (fullFilters.ownerExt) {
        fullFilters.owner = fullFilters.owner ? fullFilters.owner + ',' + fullFilters.ownerExt : fullFilters.ownerExt
        delete fullFilters.ownerExt
      }
      if (append) this.page += 1
      else this.page = 1
      const params = {
        size: this.size,
        page: this.page,
        select: 'title,description,status,topics,isVirtual,isRest,isMetaOnly,file,remoteFile,originalFile,draft.file,draft.remoteFile,draft.originalFile,count,finalizedAt',
        sort: 'createdAt:-1',
        ...fullFilters
      }
      if (!append) params.facets = 'status,draftStatus,visibility,services,concepts,topics,publicationSites,requestedPublicationSites,owner'
      if (JSON.stringify(params) !== JSON.stringify(this.lastParams)) {
        this.lastParams = params
        this.loading = true
        const datasets = await this.$axios.$get('api/v1/datasets', { params })
        if (append) datasets.results.forEach(r => this.datasets.results.push(r))
        else this.datasets = datasets
        this.$store.dispatch('breadcrumbs', [{ text: this.$tc('datasets', datasets.count) }])
        this.filtered = !!this.filters.q || hasFacetFilter
        this.loading = false

        // if the page is too large for the user to trigger a scroll we append results immediately
        await this.$nextTick()
        await this.$nextTick()
        const html = document.getElementsByTagName('html')
        if (html[0].clientHeight >= (html[0].scrollHeight - 200) && this.datasets.results.length < this.datasets.count) {
          this.refresh(true)
        }
      }
    }
  }
}
